import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import {
    createClass,
    deleteClass,
    fetchClass,
    fetchClasses,
    withRetry,
    updateClassesTemplateTests,
    fetchClassesTemplateTests,
} from '../../utils/common-functions';

function* fetchAllClasses() {
    if (yield select(({ classes }) => classes.loading)) {
        return;
    }
    yield put({
        type: actions.CLASSES_FETCH_LOADING,
        payload: { loading: true },
    });
    try {
        const classes = yield call(withRetry(fetchClasses));
        yield put({ type: actions.CLASSES_FETCHED, payload: classes.data });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'As turmas não puderam ser carregadas. Tente recarregar a página',
            },
        });
    }
    yield put({
        type: actions.CLASSES_FETCH_LOADING,
        payload: { loading: false },
    });
}

function* fetchOneClass({ payload }) {
    try {
        const response = yield call(withRetry(fetchClass), payload);
        yield put({ type: actions.CLASS_FETCHED, payload: response.data });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'A turma não pôde ser carregada. Tente recarregar a página',
            },
        });
    }
}

function* addClass({ payload: { typeTestsValues, ...classBody } }) {
    try {
        const response = yield createClass(classBody);
        yield updateClassesTemplateTests({
            classId: classBody.classId,
            data: typeTestsValues,
        });
        yield put({ type: actions.CLASS_CREATED, payload: response.data });
        yield put({ type: actions.ASYNC_FETCH_CLASSES });
    } catch (err) {
        if (
            err.response &&
            err.response.data.error_description ===
                'Teste deve ter status diferente de Incompleto'
        ) {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'O teste está incompleto e não pode ser selecionado para a turma',
                },
            });
        } else {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'As alterações não puderam ser salvas. Tente novamente',
                },
            });
        }
    }
}

function* removeClass({ payload }) {
    try {
        yield deleteClass(payload);
        yield put({ type: actions.CLASS_DELETED, payload });
    } catch (e) {
        if (e.response.status === 400) {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'A operação não pode ser completada, verifique se a turma não possui matrículas ativas.',
                },
            });
        } else {
            yield put({
                type: actions.REQUEST_ERROR,
                payload: {
                    message:
                        'As alterações não puderam ser salvas. Tente novamente',
                },
            });
        }
    }
}

function* asyncFetchClassTemplateTests({ payload: { classId } }) {
    try {
        const response = yield fetchClassesTemplateTests({
            classId: classId,
        });
        yield put({
            type: actions.CHANGE_CLASS_TEMPLATE_TESTS,
            payload: response.data,
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível realizar os testes do curso.',
            },
        });
    }
}

export default function* classes() {
    yield takeLatest(actions.ASYNC_FETCH_ADMIN_DATA, fetchAllClasses);
    yield takeLatest(actions.ASYNC_FETCH_CLASSES, fetchAllClasses);
    yield takeLatest(actions.ASYNC_FETCH_CLASS, fetchOneClass);
    yield takeEvery(actions.ASYNC_DELETE_CLASS, removeClass);
    yield takeEvery(actions.ASYNC_CREATE_CLASS, addClass);
    yield takeEvery(
        actions.ASYNC_FETCH_CLASS_TEMPLATE_TESTS,
        asyncFetchClassTemplateTests,
    );
}



// WEBPACK FOOTER //
// ./src/components/classes/classes.saga.js